import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IConfirmDeletionDialogProps {
    dialogName: string;
    hideDialog: () => void;
    body: string;
    confirmAction: () => void;
}

const ConfirmDeletionDialog = (props: IConfirmDeletionDialogProps) => {
    return (
        <Dialog title="Confirm Deletion" dialogName={props.dialogName} bodyStyle={{ width: '12%' }}>
            <p>{props.body}</p>
            <div className="form-row" style={{ marginTop: '2rem', marginLeft: '33%', textAlign: 'center' }}>
                <Button
                    className="blue-hover-button"
                    intent="danger"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Delete'}
                    onClick={() => props.confirmAction()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>

        </Dialog>
    );
};

export default ConfirmDeletionDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/dialogs/ConfirmDeletionDialog.tsx